import { render, staticRenderFns } from "./Develop.vue?vue&type=template&id=1fb77662&scoped=true&"
import script from "./Develop.vue?vue&type=script&lang=js&"
export * from "./Develop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fb77662",
  null
  
)

export default component.exports